import type { MediaItem } from "@/types/media";

export const movies: MediaItem[] = [
  {
    id: "m1",
    title: "星河归途",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%2C%20lone%20astronaut%20silhouette%20gazing%20at%20a%20vast%20glowing%20nebula%2C%20deep%20blue%20and%20teal%20palette%20with%20warm%20orange%20horizon%20glow%2C%20dramatic%20volumetric%20lighting%2C%20film%20grain%2C%20minimalist%20stylish%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m1&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20astronaut%20standing%20on%20an%20alien%20desert%20planet%20under%20a%20giant%20ringed%20planet%2C%20deep%20blue%20night%20sky%20with%20orange%20horizon%20glow%2C%20epic%20scale%2C%20volumetric%20light%2C%20atmospheric%20haze%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m1&orientation=landscape",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.9,
    duration: "148分钟",
    director: "A. 雷诺兹",
    actors: ["L. 卡特", "M. 桑德斯", "R. 陈"],
    synopsis:
      "一名孤独的宇航员在深空执行最后一次补给任务时，意外接收到了来自失落殖民地的信号。",
    storyline: [
      "在人类星际扩张的末期，导航员艾登被派往边远星域执行一次例行的补给任务。任务途中，他捕获到一段来自早已失联的殖民地「归途站」的微弱信号。",
      "随着艾登不断接近信号源，他发现那里隐藏着一段被刻意抹去的航行记录，以及一个关系到整片星域命运的抉择。孤独、时间与记忆，在深空中被无限放大。",
      "影片以冷静克制的镜头语言，讲述了一场关于归途与救赎的星际之旅。",
    ],
    tags: ["硬科幻", "太空", "孤独英雄"],
    clicks: 128400,
    updatedAt: "2025-10-03",
  },
  {
    id: "m2",
    title: "长安夜雨",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20epic%20movie%20poster%2C%20ancient%20Chinese%20city%20under%20heavy%20rain%20at%20night%2C%20lantern%20glow%20and%20deep%20blue%20storm%20sky%2C%20warm%20orange%20firelight%20accents%2C%20dramatic%20volumetric%20lighting%2C%20film%20grain%2C%20elegant%20minimalist%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m2&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20ancient%20Chinese%20imperial%20palace%20courtyard%20in%20torrential%20night%20rain%2C%20orange%20lantern%20light%20reflecting%20on%20wet%20stone%2C%20deep%20blue%20storm%20clouds%2C%20epic%20scale%2C%20volumetric%20light%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m2&orientation=landscape",
    year: 2025,
    region: "大陆",
    genres: ["历史", "战争", "剧情"],
    rating: 8.6,
    duration: "162分钟",
    director: "陈牧之",
    actors: ["周砚", "林清和", "许南舟"],
    synopsis:
      "安史之乱的前夜，一位低阶史官在连绵夜雨中发现了一份足以改写王朝命运的密卷。",
    storyline: [
      "天宝末年，长安城连月阴雨。年轻的史官裴知远在整理旧档时，偶然翻出一卷被蜡封的密录，其上记载着一场尚未发生的兵变。",
      "他必须在风暴来临之前找到可信之人，也要在层层权谋中分辨，谁才是真正的敌人。雨夜的长安，灯火与刀光交叠。",
      "影片以宏大的历史质感与细腻的人物刻画，呈现一个王朝由盛转衰的瞬间。",
    ],
    tags: ["古装", "权谋", "大制作"],
    clicks: 96400,
    updatedAt: "2025-09-28",
  },
  {
    id: "m3",
    title: "城市追光者",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%2C%20young%20person%20standing%20on%20a%20skyscraper%20rooftop%20overlooking%20a%20glowing%20city%20at%20dusk%2C%20deep%20blue%20night%20and%20warm%20orange%20window%20lights%2C%20dramatic%20lighting%2C%20film%20grain%2C%20modern%20minimalist%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m3&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20cityscape%20at%20blue%20hour%2C%20glowing%20skyscrapers%20with%20warm%20orange%20window%20lights%2C%20light%20trails%20on%20wet%20streets%2C%20deep%20blue%20sky%2C%20atmospheric%20haze%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m3&orientation=landscape",
    year: 2025,
    region: "大陆",
    genres: ["剧情", "都市"],
    rating: 8.2,
    duration: "全36集",
    director: "苏映川",
    actors: ["顾南音", "邵北", "江晚晴"],
    synopsis:
      "一群在城市深夜中奔波的普通人，用各自的方式追逐着属于自己的那束光。",
    storyline: [
      "深夜的急诊室、凌晨的便利店、还在亮着灯的写字楼，构成了这座城市最真实的底色。",
      "剧集以群像的方式，讲述六位性格迥异的都市人在一年四季里的相遇、挣扎与成长。他们互不相识，却在某个夜晚被同一束光照亮。",
      "温暖而不失现实感，是这部剧最打动人的地方。",
    ],
    tags: ["都市群像", "治愈", "现实题材"],
    clicks: 88700,
    updatedAt: "2025-10-01",
  },
  {
    id: "m4",
    title: "雾都谜案",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20mystery%20poster%2C%20detective%20silhouette%20in%20a%20foggy%20old%20city%20street%20at%20night%2C%20deep%20blue%20mist%20and%20warm%20orange%20streetlamp%20glow%2C%20moody%20dramatic%20lighting%2C%20film%20grain%2C%20minimalist%20suspense%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m4&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20foggy%20victorian%20city%20street%20at%20night%2C%20gas%20lamp%20orange%20glow%20through%20deep%20blue%20mist%2C%20wet%20cobblestones%2C%20atmospheric%20suspense%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m4&orientation=landscape",
    year: 2024,
    region: "欧美",
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.7,
    duration: "全12集",
    director: "H. 布莱克",
    actors: ["E. 华纳", "T. 摩尔", "S. 里德"],
    synopsis:
      "浓雾笼罩的老城里，一桩尘封十年的悬案随着一封匿名信重新浮出水面。",
    storyline: [
      "退休警探哈里斯本以为余生将在平静中度过，直到一封没有署名的信被塞进他的门缝，里面是十年前那起悬案唯一的现场照片。",
      "随着调查深入，他发现当年所有相关人员都在刻意回避某个名字。迷雾之下，真相与谎言只有一线之隔。",
      "本剧以极佳的摄影质感与层层反转的叙事，成为年度悬疑口碑之作。",
    ],
    tags: ["推理", "反转", "英伦"],
    clicks: 112300,
    updatedAt: "2025-09-20",
  },
  {
    id: "m5",
    title: "夏日便利店",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20comedy%20poster%2C%20cozy%20small%20convenience%20store%20glowing%20at%20summer%20night%2C%20two%20young%20people%20talking%2C%20warm%20orange%20light%20against%20deep%20blue%20evening%2C%20soft%20dramatic%20lighting%2C%20film%20grain%2C%20minimalist%20warm%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m5&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20cozy%20convenience%20store%20at%20summer%20dusk%2C%20warm%20orange%20interior%20glow%20spilling%20onto%20a%20quiet%20street%2C%20deep%20blue%20twilight%20sky%2C%20nostalgic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m5&orientation=landscape",
    year: 2025,
    region: "日韩",
    genres: ["爱情", "喜剧", "剧情"],
    rating: 8.1,
    duration: "121分钟",
    director: "李准浩",
    actors: ["金敏序", "朴夏恩", "郑宇成"],
    synopsis:
      "在街角那间 24 小时便利店里，两个夜班店员用一个夏天的时光，学会了如何告别。",
    storyline: [
      "小镇的便利店是整个夏天最亮的地方。打工的大学生理沙遇见了同样上夜班的青年俊，两人从沉默的同事，变成分享深夜便当与心事的伙伴。",
      "夏天结束时，他们都明白，有些相遇注定短暂，却足以照亮往后很长的一段路。",
      "这是一部温柔、克制的夏日小品，关于成长，也关于放下。",
    ],
    tags: ["夏日", "治愈", "青春"],
    clicks: 64200,
    updatedAt: "2025-08-15",
  },
  {
    id: "m6",
    title: "深空纪元",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20epic%20space%20opera%20poster%2C%20massive%20fleet%20of%20spaceships%20before%20a%20giant%20blue%20gas%20planet%2C%20orange%20engine%20glow%2C%20deep%20blue%20cosmos%2C%20dramatic%20scale%2C%20volumetric%20lighting%2C%20film%20grain%2C%20minimalist%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m6&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20space%20battle%20scene%2C%20massive%20starship%20fleet%20near%20a%20giant%20blue%20gas%20planet%2C%20orange%20engine%20trails%2C%20deep%20blue%20nebula%20background%2C%20epic%20scale%2C%20volumetric%20lighting%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m6&orientation=landscape",
    year: 2024,
    region: "欧美",
    genres: ["科幻", "动作", "冒险"],
    rating: 8.4,
    duration: "155分钟",
    director: "N. 沃克",
    actors: ["D. 凯恩", "P. 罗西", "A. 林"],
    synopsis:
      "当两个文明为同一颗星球展开争夺，一名谈判官必须在战争与和平之间做出选择。",
    storyline: [
      "深空纪元 2371 年，人类与泽拉联盟就边境星球的归属问题陷入僵局。经验丰富的谈判官伊莎被派往前线，试图在开战前促成和解。",
      "然而她逐渐发现，真正想要的战争的，并非台面上的任何一方。",
      "影片以恢弘的太空视效与紧凑的节奏，探讨了战争背后的人性博弈。",
    ],
    tags: ["太空歌剧", "视效大片", "战争"],
    clicks: 103600,
    updatedAt: "2025-08-22",
  },
  {
    id: "m7",
    title: "山河故人传",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20chinese%20period%20drama%20poster%2C%20lone%20scholar%20figure%20before%20vast%20misty%20mountains%20and%20rivers%20at%20dawn%2C%20deep%20blue%20ink%20washing%20tones%20with%20warm%20orange%20sunrise%20accent%2C%20dramatic%20atmosphere%2C%20film%20grain%2C%20elegant%20minimalist%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m7&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20misty%20ancient%20chinese%20mountains%20and%20rivers%20at%20dawn%2C%20deep%20blue%20ink%20tones%20with%20warm%20orange%20sunrise%20light%2C%20epic%20landscape%2C%20atmospheric%20haze%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m7&orientation=landscape",
    year: 2025,
    region: "大陆",
    genres: ["历史", "剧情"],
    rating: 8.8,
    duration: "全40集",
    director: "陆见山",
    actors: ["沈砚舟", "白雨棠", "程亦风"],
    synopsis:
      "一位游历四方的书生，用半生时间走遍山河，记录下乱世之中一个又一个平凡人的故事。",
    storyline: [
      "朝代更迭之际，书生沉砚离家远行，只为完成恩师未竟的一部地方志。",
      "他走过烽火与桃源，遇见将军、商贾、农人与流民，每一个人都是这个大时代里微小却真实的一笔。",
      "剧集以水墨般的镜头与厚重的历史质感，描绘出一幅流动的山河画卷。",
    ],
    tags: ["历史正剧", "群像", "水墨质感"],
    clicks: 79500,
    updatedAt: "2025-09-15",
  },
  {
    id: "m8",
    title: "无声证词",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%2C%20a%20single%20witness%20standing%20in%20a%20dark%20courtroom%20beam%20of%20light%2C%20deep%20blue%20shadows%20with%20warm%20orange%20highlight%2C%20tense%20dramatic%20lighting%2C%20film%20grain%2C%20minimalist%20suspense%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m8&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20empty%20night%20city%20street%20with%20a%20lone%20figure%20under%20a%20single%20streetlight%2C%20deep%20blue%20darkness%20with%20warm%20orange%20glow%2C%20tense%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m8&orientation=landscape",
    year: 2024,
    region: "港台",
    genres: ["悬疑", "犯罪"],
    rating: 8.5,
    duration: "134分钟",
    director: "杜敬言",
    actors: ["梁文彦", "苏芷晴", "何家俊"],
    synopsis:
      "一名唯一目击者的证词反复变化，检察官必须在真相与正义之间寻找那条最窄的路。",
    storyline: [
      "一起看似普通的案件，因为唯一目击者前后矛盾的证词而陷入僵局。年轻检察官程立决定独自追查，却发现每一个证人都藏着自己的秘密。",
      "当沉默成为最有力的证词，真相的重量才刚刚显现。",
      "影片节奏紧凑、反转不断，是近年港产犯罪片的口碑之作。",
    ],
    tags: ["法庭", "反转", "犯罪"],
    clicks: 71300,
    updatedAt: "2025-07-30",
  },
  {
    id: "m9",
    title: "我们的青春纪事",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20drama%20poster%2C%20group%20of%20students%20on%20a%20school%20rooftop%20at%20golden%20hour%2C%20deep%20blue%20evening%20sky%20with%20warm%20orange%20sunlight%2C%20nostalgic%20atmosphere%2C%20film%20grain%2C%20minimalist%20warm%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m9&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20school%20campus%20at%20golden%20hour%2C%20long%20shadows%20on%20the%20track%20field%2C%20deep%20blue%20sky%20with%20warm%20orange%20sunset%2C%20nostalgic%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m9&orientation=landscape",
    year: 2025,
    region: "大陆",
    genres: ["爱情", "剧情", "家庭"],
    rating: 8.0,
    duration: "全24集",
    director: "温以宁",
    actors: ["夏语", "林昭", "陈屿"],
    synopsis:
      "一本被传阅了整个高中的毕业纪念册，串起了六个少年横跨十年的青春与遗憾。",
    storyline: [
      "高三那年的春天，一本纪念册开始在班里悄悄传阅，每个拿到它的人都会写下自己的秘密。",
      "十年后，当年的少年们各奔东西，却因为一场同学会重新聚首，翻开那本早已泛黄的册子。",
      "剧集以细腻的笔触，讲述成长、友情与初恋，让人笑着笑着就红了眼眶。",
    ],
    tags: ["青春", "成长", "回忆杀"],
    clicks: 82100,
    updatedAt: "2025-09-05",
  },
  {
    id: "m10",
    title: "龙脊",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20adventure%20poster%2C%20a%20lone%20climber%20silhouette%20against%20a%20dramatic%20mountain%20ridge%20at%20storm%20dawn%2C%20deep%20blue%20clouds%20with%20warm%20orange%20light%20breaking%20through%2C%20epic%20scale%2C%20dramatic%20lighting%2C%20film%20grain%2C%20minimalist%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20mountain%20landscape%20at%20storm%20dawn%2C%20dramatic%20jagged%20ridge%2C%20deep%20blue%20clouds%20with%20warm%20orange%20light%20breaking%20through%2C%20epic%20scale%2C%20atmospheric%20haze%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m10&orientation=landscape",
    year: 2024,
    region: "大陆",
    genres: ["动作", "冒险"],
    rating: 7.9,
    duration: "137分钟",
    director: "武承岳",
    actors: ["赵戈", "孟繁星", "韩烈"],
    synopsis:
      "一支登山队在暴风雪来临前必须翻越传说中的「龙脊」，而真正的危险来自队伍内部。",
    storyline: [
      "多年未有人成功登顶的「龙脊」，因为一次科学考察重新成为焦点。经验丰富的领队带着新老队员出发，目标只有一个：抢在暴风雪前穿越山脊。",
      "随着海拔升高，缺氧、猜疑与旧日恩怨逐渐浮出水面。在山与人的较量中，谁才能活着回来？",
      "影片实景拍摄，动作场面惊险刺激，视觉冲击力十足。",
    ],
    tags: ["冒险", "实景拍摄", "极限"],
    clicks: 69800,
    updatedAt: "2025-06-18",
  },
  {
    id: "m11",
    title: "孤岛信号",
    type: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20mystery%20poster%2C%20remote%20research%20station%20on%20a%20dark%20island%20with%20a%20glowing%20radio%20tower%2C%20deep%20blue%20storm%20sea%20with%20warm%20orange%20beacon%20light%2C%20tense%20atmosphere%2C%20film%20grain%2C%20minimalist%20suspense%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20remote%20island%20research%20station%20at%20night%2C%20deep%20blue%20stormy%20sea%20and%20sky%2C%20warm%20orange%20radio%20tower%20beacon%20glow%2C%20atmospheric%20suspense%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m11&orientation=landscape",
    year: 2025,
    region: "欧美",
    genres: ["科幻", "悬疑"],
    rating: 8.3,
    duration: "全10集",
    director: "K. 林德",
    actors: ["J. 佩里", "M. 道森", "C. 韦伯"],
    synopsis:
      "孤岛科考站收到了一段不可能存在的信号，站内的八个人开始怀疑彼此都不是原来的自己。",
    storyline: [
      "北大西洋上的一座孤岛科考站，常年只有八名研究员驻守。某个风雪夜，通讯设备突然接收到一段加密信号，而信号的来源，是三天后的时间戳。",
      "随着异常事件接连发生，站内的人逐渐意识到，他们要面对的也许不是外部的威胁。",
      "本剧以密闭空间与心理惊悚见长，氛围营造一流。",
    ],
    tags: ["密闭空间", "科幻悬疑", "烧脑"],
    clicks: 87400,
    updatedAt: "2025-09-25",
  },
  {
    id: "m12",
    title: "山海幻夜",
    type: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20fantasy%20poster%2C%20mythical%20creatures%20and%20a%20young%20hero%20before%20a%20moonlit%20ancient%20landscape%2C%20deep%20blue%20night%20with%20warm%20orange%20lantern%20glow%2C%20painterly%20art%20style%2C%20dramatic%20lighting%2C%20elegant%20composition%2C%20high%20detail&width=400&height=600&seq=cth-cover-m12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20painterly%20shot%20of%20a%20mythical%20ancient%20landscape%20at%20night%2C%20floating%20mountains%20and%20glowing%20creatures%2C%20deep%20blue%20sky%20with%20warm%20orange%20lantern%20light%2C%20fantasy%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=1280&height=720&seq=cth-bd-m12&orientation=landscape",
    year: 2025,
    region: "大陆",
    genres: ["动画", "奇幻", "冒险"],
    rating: 8.6,
    duration: "118分钟",
    director: "顾星野",
    actors: ["（配音）叶知秋", "（配音）罗一鸣"],
    synopsis:
      "少年为救回被神兽带走的妹妹，踏上穿越《山海经》异界的奇幻旅程。",
    storyline: [
      "民间传闻，每逢月圆之夜，古老的妖兽便会从山海画卷中苏醒。少年阿远亲眼看着妹妹被一只九尾灵狐带走，从此踏上了追寻之路。",
      "在异界，他结识了会说人话的神兽、被遗忘的山神，也逐渐明白，真正需要被拯救的，远不止他的妹妹。",
      "影片以极具东方美学的画笔风格，构建出一个瑰丽磅礴的神话世界。",
    ],
    tags: ["国漫", "神话", "合家欢"],
    clicks: 91600,
    updatedAt: "2025-10-06",
  },
];

export const featuredIds: string[] = ["m1", "m12", "m4", "m11", "m2"];